import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { AuthConfiguration } from 'src/app/configuration/auth/auth-configuration';
import { Observable } from 'rxjs';
import { BasicResponse, UserLoginView } from '@model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  })
  constructor(public http:HttpClient) { }


  // login
  authLogin():Observable<BasicResponse<UserLoginView>> {
    return this.http.get<BasicResponse<UserLoginView>>(AuthConfiguration.authLogin,{headers : this.headers});
  }


  // elenco ruoli utente
  userRoles(codiceFiscale:string):Observable<any>  {
    return this.http.get<any>(AuthConfiguration.getRuoliUtente + codiceFiscale,{headers : this.headers});
  }


  // flag utente assistenza
  isUtenteAssistenza():Observable<any>  {
    return this.http.get<any>(AuthConfiguration.isUtenteAssistenza,{headers : this.headers});
  }

}
